export const painPoints = [
  { icon: 'ri-time-line', text: 'You know what you want, but keep procrastinating.' },
  { icon: 'ri-brain-line', text: 'You overthink decisions and delay action.' },
  { icon: 'ri-fire-line', text: 'You lose motivation after a few days.' },
  { icon: 'ri-shield-check-line', text: 'You need confidence before taking the next step.' },
  { icon: 'ri-user-voice-line', text: 'You want guidance but do not always have someone to talk to.' },
  { icon: 'ri-eye-line', text: 'You want a different perspective on your problem.' },
  { icon: 'ri-arrow-right-circle-line', text: 'You need help turning thoughts into action.' },
];

export const coachingStyles = [
  {
    title: 'Peak Performance Coach',
    description: 'For motivation, standards, identity, energy, and personal power.',
    icon: 'ri-rocket-line',
  },
  {
    title: 'Action & Confidence Coach',
    description: 'For procrastination, hesitation, fear, and self-doubt.',
    icon: 'ri-flashlight-line',
  },
  {
    title: 'Champion Mindset Coach',
    description: 'For discipline, resilience, focus, competition, and high standards.',
    icon: 'ri-trophy-line',
  },
  {
    title: 'Inspirational Leadership Coach',
    description: 'For values, purpose, service, leadership, and meaning.',
    icon: 'ri-star-line',
  },
  {
    title: 'Habit Design Coach',
    description: 'For consistency, routines, small steps, and behaviour change.',
    icon: 'ri-repeat-line',
  },
  {
    title: 'Business Growth Coach',
    description: 'For offers, sales, marketing, strategy, execution, and income goals.',
    icon: 'ri-bar-chart-line',
  },
  {
    title: 'Calm Thinking Coach',
    description: 'For overthinking, emotional decisions, worry, and mental clarity.',
    icon: 'ri-mental-health-line',
  },
  {
    title: 'Purpose Coach',
    description: 'For direction, fulfilment, identity, contribution, and deeper personal growth.',
    icon: 'ri-compass-line',
  },
];

export const howItWorksSteps = [
  {
    step: '01',
    title: 'Tell the app what you are facing.',
    description: 'Enter your challenge, question, fear, or goal in plain language.',
    icon: 'ri-message-3-line',
  },
  {
    step: '02',
    title: 'Choose the coaching style you want.',
    description: 'Pick from eight powerful coaching perspectives.',
    icon: 'ri-user-settings-line',
  },
  {
    step: '03',
    title: 'Receive a practical coaching response.',
    description: 'Get a mindset reframe, powerful question, and next step.',
    icon: 'ri-lightbulb-line',
  },
  {
    step: '04',
    title: 'Choose your next action.',
    description: 'Commit to one small, meaningful step forward.',
    icon: 'ri-check-double-line',
  },
  {
    step: '05',
    title: 'Save your insight and track your progress.',
    description: 'Build a personal journal of growth and breakthroughs.',
    icon: 'ri-bookmark-line',
  },
];

export const features = [
  { icon: 'ri-message-2-line', title: 'Ask a Coach', description: 'Enter any question, challenge, fear, or goal and get a helpful coaching response.' },
  { icon: 'ri-exchange-line', title: 'Compare Coach Views', description: 'See the same issue from multiple coaching perspectives so you can find the insight that lands.' },
  { icon: 'ri-sun-line', title: 'Daily Coaching Check-In', description: 'Start your day with focus, intention, and one clear action.' },
  { icon: 'ri-git-branch-line', title: 'Decision Coach', description: 'Work through difficult choices with calm, structured questions.' },
  { icon: 'ri-flag-line', title: 'Goal Coach', description: 'Turn your goals into clear plans, habits, and action steps.' },
  { icon: 'ri-hammer-line', title: 'Procrastination Breaker', description: 'Identify what you are avoiding and take the smallest useful step forward.' },
  { icon: 'ri-book-2-line', title: 'Coaching Journal', description: 'Save your sessions, track your insights, and review your progress.' },
  { icon: 'ri-pie-chart-line', title: 'Weekly Growth Report', description: 'See your patterns, commitments, wins, and suggested focus for the week ahead.' },
];

export const useCases = [
  { icon: 'ri-map-pin-line', text: 'Stuck and need direction' },
  { icon: 'ri-alert-line', text: 'Avoiding something important' },
  { icon: 'ri-scales-3-line', text: 'Trying to make a big decision' },
  { icon: 'ri-chat-1-line', text: 'Preparing for a difficult conversation' },
  { icon: 'ri-building-line', text: 'Building a business' },
  { icon: 'ri-focus-3-line', text: 'Setting personal goals' },
  { icon: 'ri-shield-star-line', text: 'Trying to stay disciplined' },
  { icon: 'ri-fire-line', text: 'Feeling low on motivation' },
  { icon: 'ri-shield-check-line', text: 'Struggling with confidence' },
  { icon: 'ri-brain-line', text: 'Overthinking a situation' },
  { icon: 'ri-team-line', text: 'Trying to become a better leader' },
  { icon: 'ri-refresh-line', text: 'Needing a quick mindset reset' },
];

export const pricingPlans = [
  {
    name: 'Free',
    price: '0',
    period: 'Free for 7 days',
    description: 'Start your coaching journey',
    features: [
      '3 coaching questions per DAY',
      'Access to 3 coaching styles',
      'Daily coaching check-in',
      'Basic journal history',
    ],
    cta: 'Try It Free',
    highlighted: false,
  },
  {
    name: 'Pro',
    price: '9.99',
    period: 'month',
    description: 'Unlimited coaching power',
    features: [
      'Unlimited coaching questions',
      'All coaching styles',
      'Compare Coach Views',
      'Decision Coach',
      'Goal Coach',
      'Procrastination Breaker',
      'Saved coaching history',
      'Weekly growth report',
    ],
    cta: 'Upgrade to Pro',
    highlighted: true,
  },
  {
    name: 'Premium',
    price: '19.99',
    period: 'month',
    description: 'For serious transformation',
    features: [
      'Voice coaching',
      'Advanced action plans',
      'Custom coach builder',
      'Export coaching sessions to PDF',
      'Priority new features',
      'All Pro features included',
    ],
    cta: 'Go Premium',
    highlighted: false,
  },
];

export const beforeItems = [
  'You stay trapped in your own thoughts.',
  'You delay decisions.',
  'You wait to feel motivated.',
  'You keep replaying the same problem.',
  'You struggle to turn ideas into action.',
  'You feel like you need guidance but do not know who to ask.',
];

export const afterItems = [
  'You get an instant coaching perspective.',
  'You see the problem more clearly.',
  'You reframe fear into action.',
  'You make better decisions.',
  'You build daily momentum.',
  'You always have a coach-style guide at your fingertips.',
];

export const exampleResponses = [
  {
    style: 'Peak Performance',
    response: 'You are not lacking ability. You are lacking a stronger standard for who you are becoming. What would the version of you who already has this business do today?',
  },
  {
    style: 'Action & Confidence',
    response: 'You do not need to feel ready. You need to start before your brain talks you out of it. Take one five-minute action now.',
  },
  {
    style: 'Champion Mindset',
    response: 'Confidence is built through reps. Stop waiting for certainty and take the next rep. What is one action you can repeat daily?',
  },
  {
    style: 'Purpose Coach',
    response: 'What part of your future are you delaying by staying comfortable?',
  },
];

export const transformationPillars = [
  {
    title: 'Think Clearly',
    description: 'Slow down the noise, understand the real issue, and see your situation from a better perspective.',
    icon: 'ri-brain-line',
  },
  {
    title: 'Act Confidently',
    description: 'Turn fear, doubt, and procrastination into one practical next step.',
    icon: 'ri-arrow-right-circle-line',
  },
  {
    title: 'Transform Daily',
    description: 'Build momentum through daily check-ins, coaching reflections, and action commitments.',
    icon: 'ri-refresh-line',
  },
];

export const footerLinks = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/#features' },
      { label: 'Pricing', href: '/#pricing' },
      { label: 'How It Works', href: '/#how-it-works' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Home', href: '/' },
      { label: 'Knowledge Hub', href: '/knowledge' },
      { label: 'Blog', href: '/blog' },
      { label: 'Terms', href: '/terms' },
      { label: 'Privacy', href: '/privacy' },
      { label: 'Disclaimer', href: '/disclaimer' },
      { label: 'Contact', href: '/contact' },
      { label: 'Unsubscribe', href: '/unsubscribe' },
    ],
  },
  {
    title: 'Connect',
    links: [
      { label: 'X (Twitter)', href: 'https://x.com/TNTTerritory' },
      { label: 'LinkedIn', href: 'https://www.linkedin.com/company/topnotch-technologies' },
      { label: 'Instagram', href: 'https://www.instagram.com/topnotchterritory' },
      { label: 'Facebook', href: 'https://www.facebook.com/TopNotchTerritory/' },
    ],
  },
];